import Footer from '../b2b/Footer';

const MerchantTermsPage = () => {
  return (
    <>
      <div className='container-fluid md:container md:mx-12 mb-8'>
        <section id='merchantTerms'>
          <h2 className='text-[1.25rem] leading-[2rem] md:text-[40px] text-[#2D2D2D] md:leading-[40px] font-[400]'>
            Savers App Merchant Terms & Conditions
          </h2>
          <p className='text-base font-[400] mt-8 mb-2'>
            Effective Date: 27 August, 2026
          </p>
          <p className='text-base font-[400] mb-8'>Version: 260827</p>

          <div className='term'>
            <p className='text-base text-gray-700'>
              The Merchant Onboarding Agreement, Campaign Form, and Terms and
              Conditions (collectively “Agreement”) govern your participation in
              the Savers App Platform. By accepting these Terms and Conditions
              and paying the Onboarding Fee, you agree to the terms and
              conditions set forth below.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              1. Engagement; Campaign Forms:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              1.1. Through its relationship with Savers App, Inc. (“Savers
              App”), Advertiser has elected to participate in Savers App’s Card
              Linked Offer Program, which includes programs managed by the
              Third Parties (“Publishers”) (collectively, the “Savers App
              Platform”).
            </p>
            <p className='text-base text-gray-700 mb-4'>
              1.2. Savers App has entered into Agreements with each Publisher
              for certain services, on behalf of itself and as the
              representative of Advertiser, to promote Advertiser to Publisher’s
              customers. In order for Publishers to perform services in
              accordance with the Savers App – Publisher Terms, MasterCard
              Incorporated, Visa U.S.A. Inc., and one or more Payment Processors
              or Financial Institutions engaged by Savers App and/or Publisher
              (individually and collectively, “Card Network / Processor”) will
              need to provide Savers App and/or Publisher with certain
              information further described in this Agreement.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              2. Conduct of Campaigns
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              2.1. Fulfillment and Conduct of Campaigns: As between the Parties,
              Advertiser shall be responsible for (i) ensuring that all
              Campaigns and their fulfillment comply with applicable laws; and
              (ii) ensuring that no Campaign or related Creative or Offer shall:
              infringe or violate any third party’s intellectual property rights
              or other rights, be defamatory or obscene, or violate any law or
              regulation or the rights of privacy or personality of any third
              party.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.2. Offer Listing Information. For each Campaign, Advertiser
              shall provide to Savers App the Offer Listing information and
              materials required by the Agreement (including applicable Offer
              terms and conditions to be presented to customers), copy,
              photography, images, other descriptive materials, and links for
              all Offer Listings. Advertiser shall deliver such items to Savers
              App via the Savers App Merchants Portal, email, or other means as
              mutually determined by the Parties.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.3. Purchase Methods. Advertiser acknowledges that the Card
              Network / Processor at any given time supported by the Savers App
              shall be the only permitted means for redeeming Offers.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.4. Consumer Terms of Use. Advertiser acknowledges that the
              Savers App Platform is available to track purchases of customers
              who establish accounts on the Savers App Platform and who accept
              and abide by the applicable Terms of Use and Privacy Policy
              (“Program Terms”). Savers App and Publishers may ban the
              participation of individual customers in the Savers App Platform
              for any violation of the Program Terms or for any other reason
              determined in its sole discretion. Advertiser acknowledges that
              Savers App and/or Publishers will collect, use, and disclose
              consumer data in accordance with the Program Terms as in effect
              from time to time, the current versions of which will be made
              available to Advertiser upon request. Advertiser will have no
              liability for the violation by the consumer of Program Terms or
              for any violation of Program Terms by Savers App and Publishers.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.5. Advertiser Authorization.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.5.1. Advertiser hereby authorizes Card Network / Processor to
              monitor and release the following information to and between
              Savers App and Publishers: Advertiser’s Card Network
              identification number(s) and Advertiser’s payment card transaction
              information (including, without limitation, date, purchase amount,
              encrypted or tokenized card numbers, and payment card type) (each
              of the foregoing items individually and collectively, “Advertiser
              Information”).
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.5.2. Advertiser hereby authorizes Savers App and Publishers and
              each of the third parties with whom Savers App or Publishers may
              contract in connection with the Savers App Platform (each, a
              “Vendor,” which excludes Card Network / Processors), to (i) use or
              process Advertiser Information in order to determine rewards
              eligibility in the Program (with eligible purchases defined as
              “Qualified Purchases”), and (ii) communicate Qualified Purchases
              (date and time, purchase amount, last 4 digits of card, city /
              state / zip code, and payment card type) to Savers App for
              purposes of Savers App reporting to and billing Advertiser. Each
              Vendor has confidentiality obligations that prohibit such Vendor
              from disclosing Advertiser Information to third parties.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              2.5.3. To the extent Advertiser has an agreement with a Card
              Network / Processor, these Terms & Conditions shall not modify or
              terminate any such Advertiser – Card Network / Processor
              agreement.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              3. Advertiser Funding and Settlements:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              3.1. Settlement Funding. Advertiser agrees to fully and timely
              fund all Redemptions consummated in accordance with the applicable
              Offer terms and conditions, and remit Settlement Funds to Savers
              App in the manner described in Section 4.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              3.2. Settlement Services. Savers App and/or its Publishers will be
              responsible for Redemption Matching and Settlement services, and
              shall arrange for the clearing of Redemption Value associated with
              a Redeemed Offer to customers promptly after Advertiser makes
              available Settlement Funds in the manner described in Section 4.
              Savers App and Publishers will not be liable for any delays in
              payment due to the acts or omissions of any other Parties.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              3.3. Targeting and Redemption Qualification: Advertiser has been
              made aware of and understands the process by which Savers App
              targets cardholders for offers and tracks qualifying redemption
              activity. Targeting is based on the purchases completed using
              credit or debit cards within Savers App’s network and does not
              account for transactions paid for using other forms of payment
              such as cash, checks, money orders, ACH or credit or debit cards
              outside of Savers App’s network. Savers App tracks redemptions, as
              well as associated cash back and fees billed to advertisers,
              strictly and exclusively based on transaction activity on the
              credit and debit cards within the Savers App network. Savers App
              cannot and does not qualify redemptions based on other digital
              behaviors such as clicks, page views, activity on affiliate
              marketing links or pixel tracking. Costs for redemptions to
              Advertiser will be based solely on transaction activity at
              Advertiser amongst cardholders eligible for the offer within the
              Savers App network and are indisputable.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              4. Payment and Payment Liability:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              4.1. Invoices. Invoices will be sent to the billing address as set
              forth on the Agreement and will include information reasonably
              specified by the Agreement, including the Fee and Offer. Savers
              App shall invoice Advertiser on the 1st and 15th of each month for
              the rewards that have been approved during the previous period.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              4.2. Payment Terms. Savers App will charge the invoice amount to
              the card on record used by the Advertiser to pay the Onboarding
              Fee. All payments under this Agreement shall be made in U.S.
              dollars by payment method set forth in the Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              4.3. Expenses; Taxes. Each Party shall bear its own costs and
              expenses that may be incurred as a result of its performance of
              this Agreement. All fees payable hereunder are exclusive of taxes.
              If any governmental authority levies any taxes with respect to the
              services performed by Savers App hereunder (excluding taxes on its
              properties or income), it shall invoice the Advertiser for the
              amount of such and Advertiser shall settle such amount within
              seven (7) days after receipt of invoice.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>5. Reporting:</h3>
            <p className='text-base text-gray-700 mb-4'>
              5.1. Campaign Reporting. Savers App shall provide to Advertiser,
              on a monthly basis, a Campaign performance report, the form and
              content of which shall be mutually determined by the Parties.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              6. Trademark and Creative Licenses:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              6.1. Advertiser hereby grants to Savers App, during the term of
              the applicable Campaigns on the Savers App Platform hereunder, a
              non-exclusive, non-transferable, revocable, royalty-free, right
              and license to use, copy, display, modify for formatting purposes,
              distribute, and perform any content, creative works,
              advertisements, or marketing materials made available to Savers
              App hereunder for use in the Campaigns (the “Creative”) and
              Advertiser’s trademarks, service marks, trade names, logos,
              iconography, and/or product names (in both text and stylized
              forms) made available to Savers App for use in connection with any
              such Campaigns (“Advertiser Marks”) intended for the territory of
              the United States and Canada solely to the extent necessary to
              conduct the Campaigns as contemplated in the Agreement, including
              the right to display, promote, advertise, and access the
              Advertiser Marks, the Offer, and the Creative on the Savers App
              Platform. Savers App agrees to only display the Advertiser Marks
              and the Creative in a manner authorized by Advertiser in advance.
              The foregoing rights may be sublicensed by Savers App to its
              Publishers to the extent necessary for the performance of its
              obligations hereunder. Notwithstanding any provision herein to the
              contrary, as between the Parties, all rights, title, and interest
              in the Creative and Advertiser Marks shall remain the sole and
              exclusive property of Advertiser. Savers App and Publishers will
              comply with Advertiser’s trademark usage standards made available
              to it with respect to such use. All goodwill arising from use of
              Advertiser Marks will inure to Advertiser.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              6.2. Advertiser hereby grants to Savers App rights to use
              Company’s Name and Logos in Savers App Marketing Materials solely
              in connection with the work performed by Savers App on
              Advertisers behalf.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              7. Confidentiality; Data Rights; Privacy and Security:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              7.1.1. Confidential Information. Advertiser acknowledges that, in
              the course of performing its duties as under the Agreement, it may
              obtain information relating to Savers App which Advertiser knows
              or has reason to know is of a confidential or proprietary nature
              (“Savers App Confidential Information”). Savers App acknowledges
              that, in the course of performing its duties under the Agreement,
              it may obtain information relating to Advertiser which Savers App
              knows or has reason to know is of a confidential or proprietary
              nature (“Advertiser Confidential Information”, and, collectively
              with Savers App Confidential Information, “Confidential
              Information”). Confidential Information includes, but is not
              limited to, computer software, data, information, databases,
              protocols, reference implementation and documentation, functional
              and interface specifications, future product releases, trade
              secrets, knowhow, inventions, techniques, processes, schematics,
              software source documents, pricing and discount schedules,
              financial information and sales and marketing plans. The party
              receiving Confidential Information of the other party shall at all
              times, both during the term of this Agreement and at all times
              thereafter, keep and hold such Confidential Information in the
              strictest confidence, and shall not use such Confidential
              Information for any purpose, other than as may be reasonably
              necessary for the performance of its duties or exercise of its
              rights under this Agreement, without the disclosing party’s prior
              written consent. The receiving party shall not disclose any such
              Confidential Information to any person or entity without the
              disclosing party’s prior written consent, except to its employees
              or consultants, as necessary for purposes of performing the
              receiving party’s duties hereunder, under the terms and conditions
              no less protective of the Confidential Information than the terms
              and conditions of this Section 7.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.1.2. Exclusions from Nondisclosure and Nonuse Obligations. The
              receiving party’s obligations under Section 7.1.1 shall not apply
              to any of Confidential Information that the receiving party can
              document: (a) was in the public domain at or subsequent to the
              time such Confidential Information was communicated to the
              receiving party by the disclosing party through no fault of the
              receiving party, or (b) was rightfully in the receiving party’s
              possession free of any obligation of confidence at or subsequent
              to the time such Confidential Information was communicated to the
              receiving party by the disclosing party. A disclosure by the
              receiving party of Confidential Information (i) in response to a
              valid order by a court or other governmental body or (ii) as
              otherwise required by law shall not be considered to be a breach
              of this Agreement by the receiving party; provided, however, that
              the receiving party shall provide prompt prior written notice
              thereof to the disclosing party to enable the disclosing party to
              seek a protective order or otherwise prevent such disclosure.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.1.3. Non-Circumvention. In addition to the restrictions on
              disclosure and the handling of Confidential Information in Section
              7.1.1, neither party shall use in any manner any of other party’s
              Confidential Information for the purpose of circumventing or
              attempting to circumvent, directly or indirectly, the intent of
              this Agreement, including but not limited to, use of such
              Confidential Information to reverse-engineer proprietary
              technology, to develop competitive products or services, or to
              directly compete with the other party.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.1.4. Neither party shall disclose any of the terms and
              conditions of this Agreement to any person or entity whatsoever
              other than legal counsel, except to the extent such disclosure may
              be required for accounting or tax reporting purposes or as
              otherwise may be required by law. In addition, either party may
              disclose the existence, and the terms and conditions of this
              Agreement to such party’s current and prospective investors,
              acquirers, merger candidates and financing sources; provided that
              each such person or entity shall (a) be subject to reasonable
              obligations of confidentiality, (b) be informed of the
              confidential nature of the Confidential Information so disclosed,
              and (c) agree to hold such Confidential Information in confidence
              in a manner consistent with the terms thereof. After written
              approval from the other party, either party to this Agreement may
              publish or circulate any type of press release regarding this
              Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.2. Data Security and Privacy. Both Parties shall comply with all
              applicable laws, regulations, privacy guidelines and applicable
              agreements governing the collection and use of all non-public,
              personal information of any customer data, including without
              limitation the Gramm-Leach-Bliley Act (collectively, the “Privacy
              Rules”) to the extent applicable to the activities conducted under
              this Agreement. Both parties agree to implement appropriate
              measures designed to meet the objectives of the Privacy Rules
              including to (a) maintain the security and confidentiality of
              customer data; (b) protect against threats or hazards to the
              security or integrity of customer data; and (c) protect against
              unauthorized access to or use of customer data that could result
              in substantial harm to any customer of any person. The parties
              shall notify each other of any unauthorized disclosures of
              customer data on the same business day as the discovery. Both
              Parties will take all reasonable steps to safeguard all login and
              password information provided by Savers App to Advertiser
              hereunder, so as to ensure that no unauthorized person will have
              access to the Savers App Platform, and that no persons authorized
              to have access will make any unauthorized use thereof. Advertiser
              will promptly report to Savers App any unauthorized use of the
              Savers App Platform of which Advertiser becomes aware and will
              take such further steps as may reasonably be requested by Savers
              App to prevent unauthorized use thereof. Advertiser will comply
              with all requirements provided by or on behalf of credit card
              companies to Company in order to ensure Savers App’s compliance
              with all credit card and payment-related processing Privacy Rules,
              and not knowingly take any action that would cause the other party
              to be in breach of its agreement with the credit card company, or
              any card association networks, as applicable, or any successor
              thereto.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.3. Advertiser obtains, or may obtain, sales information from
              various sources (e.g., Card Network/Processor monthly reports
              directly to Advertiser, Advertiser’s internal sales records,
              etc.). This sales information may include some elements of data
              that are the same as the Redemption Data (defined below).
              Advertiser’s use of this separately obtained sales information is
              not subject to the restrictions in Section 7.4.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              7.4. Advertiser will only use data relating to the Savers App
              Platform or Qualified Purchases (“Redemption Data”) to confirm the
              occurrence of a Qualified Purchase. Advertiser will not use the
              Redemption Data for any other purpose. The Redemption Data is
              confidential information and, except for employees and
              subcontractors with a need to know, Advertiser will not share it
              with others. Advertiser will keep and/or use the Redemption Data
              only as long as there is a business need to have it, but not
              longer than 180 days.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              8. Intellectual Property Ownership:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              8.1. Savers App owns all right, title and interest in the Savers
              App Platform and in any other technology or materials developed by
              Savers App in the performance of the services contemplated in the
              Agreement, including any and all intellectual property rights
              therein.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              8.2. Reservation of Rights. Except as otherwise expressly stated
              in the Agreement: (i) nothing in this Agreement is intended to
              transfer from either Party to the other Party any right, title or
              interest in or to any Confidential Information or other
              intellectual property of such Party and each Party hereby reserves
              all rights in its Confidential Information and intellectual
              property; and (ii) to the extent that either Party provides or
              makes available any Confidential Information or other intellectual
              property to the other Party pursuant to this Agreement, such other
              Party and its Affiliates and their respective employees,
              contractors, agents, and other related parties shall have a
              limited, personal, non-exclusive, non-transferable license to use
              such Confidential Information and intellectual property solely for
              the purpose of performing such Party’s obligations or exercising
              its rights under this Agreement; and (iii) no other license is
              granted to either Party under this Agreement, by implication or
              otherwise, with respect to any Confidential Information or other
              intellectual property that may be provided or made available by
              the other Party to such Party under this Agreement.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>9. Termination:</h3>
            <p className='text-base text-gray-700 mb-4'>
              9.1. Term. This Agreement shall be effective as of the Effective
              Date defined in Section 15.2 and shall continue for the duration
              of two (2) years or other term stated in the Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              9.2. Termination for Cause. Either Party may terminate this
              Agreement: (i) upon thirty (30) business days prior written notice
              if the other Party commits any material breach of this Agreement
              and fails to cure the breach during such notice period; or (ii)
              immediately upon written notice if (A) the other Party ceases
              doing business as a going concern, is dissolved or otherwise
              terminates its business operations, (B) the other Party files a
              petition in bankruptcy or institutes any action under federal or
              state law for the relief of debtors, or (C) the other Party seeks
              or consents to the appointment of an administrator, receiver,
              custodian, or similar official for the winding down of its
              business.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              9.3. Wind-Down. Upon any termination or expiration of this
              Agreement, Parties shall collaborate as reasonably necessary to
              effectuate an orderly wind-down of any live Campaigns, and all
              provisions of this Agreement shall survive termination to the
              extent necessary to govern and enforce such wind-down.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              9.4. Termination of this Agreement shall not relieve the parties
              of any obligation or liability accruing prior to such termination.
              Sections 7.1, 8.2, 9, 11, 12, 13, and 15 of this Agreement,
              together with any outstanding payment obligations, shall survive
              any termination of this Agreement.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              10. Representations and Warranties:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              10.1. Mutual Representations and Warranties. Each Party hereby
              represents and warrants to the other Party that: (a) it has the
              necessary authority to enter into and perform this Agreement and
              is not subject to any agreement or other constraint that would
              prohibit or restrict its right or ability to enter into, or carry
              out, its obligations hereunder; and (b) it shall comply with and
              shall not violate any applicable laws in connection with its
              performance of this Agreement or the conduct of its business as it
              pertains to this Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              10.2. Advertiser Representations and Warranties. Advertiser hereby
              represents and warrants to Savers App that: (a) it is authorized
              and has the necessary third party consents to grant the licenses
              for the Creative and Advertiser Marks associated with each
              Campaign; (b) no Creative, Advertiser Marks, or Offer associated
              with such Campaign shall: infringe or violate any third party’s
              intellectual property rights or other rights, be defamatory or
              obscene, or violate any law or regulation or the rights of privacy
              or personality of any third party; and (c) such Campaign(s) and
              related Offer shall comply with all applicable laws.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>11. Indemnification:</h3>
            <p className='text-base text-gray-700 mb-4'>
              11.1. Indemnification by Advertiser. Advertiser shall defend,
              indemnify and hold Savers App, its officers, directors,
              affiliates, and employees harmless from and against any and all
              losses, liabilities, damages and expenses (including reasonable
              attorney’s’ fees) arising from any claim or action taken against
              Savers App by any third party resulting from or relating to (a)
              any gross negligence or willful misconduct by Advertiser relating
              to this Agreement, or (b) any breach or alleged breach by
              Advertiser of any of its representations, warranties or
              obligations by Advertiser under this Agreement, including but not
              limited to its confidentiality obligations and PCI Compliance;
              provided that Savers App must (i) give Advertiser prompt written
              notice of all such claims or actions instituted against it, and
              (ii) provide Advertiser with the opportunity to elect to take
              over, settle or defend such claims or actions through counsel of
              Advertiser’s own choice and under Advertiser’s sole discretion and
              at its own expense.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              11.2. Indemnification by Savers App. Savers App shall defend,
              indemnify and hold Advertiser, its officers, directors,
              affiliates, and employees harmless from and against any and all
              losses, liabilities damages and expenses (including reasonable
              attorney’s’ fees) arising from any claim or action taken against
              Advertiser by any third party resulting from or relating to (a)
              any gross negligence or willful misconduct by Savers App relating
              to this Agreement, or (b) any breach or alleged breach by Savers
              App of any of its representations, warranties or obligations under
              this Agreement by Savers App, including, but not limited to, a
              breach of its confidentiality obligations and PCI Compliance;
              provided that Advertiser must (i) give Savers App prompt written
              notice of all such claims or actions instituted against it, and
              (ii) provide Savers App with the opportunity to elect to take
              over, settle or defend such claims or actions through counsel of
              Savers App’s own choice and under Savers App’s sole discretion and
              at its own expense.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              11.3. Settlement. The indemnifying party shall not compromise or
              settle any claim in a manner which affects the indemnified party’s
              rights, makes admissions on the indemnified party’s behalf or
              obligates the indemnified party to take or not take any action,
              including without limitation the payment of money, without the
              indemnified party’s prior written approval, which shall not be
              unreasonably withheld or delayed.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              12. Limitation of Liability:
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              12.1. Indirect Damages. EXCEPT FOR A PARTY’S INDEMNITY OBLIGATIONS
              UNDER THIS AGREEMENT OR A BREACH BY A PARTY OF ITS
              CONFIDENTIALITY OBLIGATIONS UNDER SECTION 7 ABOVE, NEITHER PARTY
              SHALL BE LIABLE TO THE OTHER PARTY FOR ANY SPECIAL, INCIDENTAL OR
              CONSEQUENTIAL DAMAGES SUCH AS, BUT NOT LIMITED TO, COMPENSATION OR
              DAMAGES FOR LOSS OF PRESENT OR PROSPECTIVE PROFITS OR REVENUES,
              LOSS OF ACTUAL OR ANTICIPATED PROFITS, INVESTMENTS OR COMMITMENTS
              MADE IN CONNECTION WITH THIS AGREEMENT OR IN CONNECTION WITH THE
              PERFORMANCE OF OBLIGATIONS HEREUNDER.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              12.2. Liability Cap. EXCEPT FOR A PARTY’S INDEMNITY OBLIGATIONS
              UNDER THIS AGREEMENT, A BREACH BY A PARTY OF ITS CONFIDENTIALITY
              OBLIGATIONS UNDER SECTION 7 ABOVE, NEITHER PARTY SHALL BE LIABLE
              TO THE OTHER PARTY IN AN AMOUNT IN THE AGGREGATE GREATER THAN 12
              MONTHS’ WORTH OF FEES UNDER THE AGREEMENT, EVEN IF NOT PAID BY
              ADVERTISER
            </p>
            <p className='text-base text-gray-700 mb-4'>
              12.3. Card Network / Processor. Card Network / Processor will not
              be liable under any circumstances for (i) the release of or misuse
              of data provided under this authorization and used in connection
              with SAVERS APP PLATFORM transactions by customers, SAVERS APP,
              Advertiser, PUBLISHERS or subcontractors or agents of any of the
              foregoing parties; (ii) any errors by or arising from the acts or
              omissions of customers, SAVERS APP, advertiser, Publishers or
              subcontractors or agents of any of the foregoing parties in
              connection with any Savers App platforms transaction.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              12.4. Applicability. THE LIMITATIONS SET FORTH IN THIS SECTION 12
              SHALL APPLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW AND
              NOTWITHSTANDING THE FAILURE OF THE ESSENTIAL PURPOSE OF ANY
              LIMITED REMEDIES SET FORTH IN THIS AGREEMENT. IF APPLICABLE LAW
              PRECLUDES A PERSON FROM DISCLAIMING A PARTICULAR KIND OF DAMAGE
              OR TO CAP THE LIABILITY FOR CERTAIN TYPES OF ACTIONS OR CLAIMS,
              THEN THE ABOVE PROVISIONS SHALL BE DEEMED AMENDED TO CONFORM WITH
              APPLICABLE LAW AND THE BALANCE OF THIS SECTION SHALL REMAIN IN
              FULL FORCE AND EFFECT.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              12.5. Allocation of Risk. THE PARTIES HAVE FULLY CONSIDERED AND
              FIND REASONABLE THE FOREGOING ALLOCATION OF RISK, AND THE
              FOREGOING LIMITATIONS IN THIS SECTION ARE AN ESSENTIAL BASIS OF
              THE BARGAIN BETWEEN THE PARTIES.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>13. Miscellaneous:</h3>
            <p className='text-base text-gray-700 mb-4'>
              13.1. Relationship of the Parties. The parties will at all times
              act independently, and their relationship will be that of
              independent contractors. No agency, partnership, joint venture or
              similar relationship shall be deemed to be created by this
              Agreement or by any other document or dealings between the
              parties. Neither party will have the right to create any
              obligation or duty, express or implied, on behalf of the other
              party.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.2. Assignment. Except as otherwise expressly provided under
              this Agreement neither this Agreement nor any right or obligation
              hereunder may be assigned or otherwise transferred (whether
              voluntarily, by operation of law, or otherwise), without the prior
              express written consent of the other party; provided, however,
              that either party may, without such consent, assign this Agreement
              and its rights and obligations hereunder in connection with the
              transfer or sale of all or substantially all of its business, or
              in the event of its merger, consolidation, change in control or
              similar transaction. Any permitted assignee shall assume all
              obligations of its assignor under this Agreement. Any purported
              assignment or transfer in violation of this Section 13.2 shall be
              void.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.3. No Waiver. The failure of either party to enforce at any
              time or for any period any of the provisions of this Agreement
              shall not be construed to be a waiver of those provisions or of
              the right of that party thereafter to enforce each and every
              provision hereof.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.4. Notices. Except where provided otherwise, notices hereunder
              shall be in writing and shall be deemed to have been fully given
              and received when sent electronically by Email, delivered by hand,
              sent by nationally recognized overnight courier, or sent by
              registered or certified mail, return receipt requested, postage
              prepaid, and properly addressed to the offices of the respective
              parties.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.5. Governing Law. This Agreement shall be governed and
              construed in accordance with the laws of the State of California,
              without reference to rules regarding conflicts of law.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.6. Severability. If any provision of this Agreement shall be
              held to be illegal, invalid or unenforceable, each party agrees
              that such provision shall be enforced to the maximum extent
              permissible so as to effect the intent of the parties, and the
              validity, legality and enforceability of the remaining provisions
              of this Agreement shall not in any way be affected or impaired
              thereby. If necessary to affect the intent of the parties, the
              parties shall negotiate in good faith to amend this Agreement to
              replace the unenforceable language with enforceable language that
              reflects such intent as closely as possible.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.7. Force Majeure. The parties to this Agreement shall be
              excused from any performance required hereunder (except the
              obligation to tender payments) if such performance is rendered
              impossible or unfeasible due to any catastrophes or other major
              events beyond their reasonable control, including without
              limitation, war, riot and insurrection; laws, proclamations,
              edicts, ordinances or regulations; strikes, lockouts or other
              serious labor disputes; earthquakes, floods, fires, explosions or
              other natural disasters. When such events have abated, the
              parties’ respective obligations hereunder shall resume.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.8. Headings. The title of the various sections of this
              Agreement are used for convenience of reference only and are not
              intended to and shall not in any way enlarge or diminish the
              rights or obligations of the parties or affect the meaning or
              construction of this document.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.9. Counterparts. This Agreement may be executed in any number
              of counterparts, each of which shall be deemed to be an original,
              but all of which together shall constitute one and the same
              instrument.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              13.10. Entire Agreement. The Agreement is the complete statement
              of the agreement between the parties concerning the subject matter
              hereof. The Agreement constitutes the entire agreement and final
              understanding of the parties with respect to the subject matter
              hereof and supersedes and terminates any and all prior or
              contemporaneous negotiations, representations, understandings,
              discussions, offers or agreements between the parties, whether
              written or verbal, express or implied, relating in any way to the
              subject matter hereof. This Agreement is intended by the parties
              to be a complete and wholly integrated expression of their
              understanding and agreement, and it may not be altered, amended,
              modified or otherwise changed in any way except by a written
              instrument, which specifically identifies the intended alteration,
              amendment, modification or other change and clearly expresses the
              intention to so change this Agreement, agreed in writing by
              authorized representatives of Savers App and Advertiser, which may
              be effected electronically, including by the acceptance method
              described in Section 15.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>14. Defined Terms</h3>
            <p className='text-base text-gray-700 mb-4'>
              14.1. “Advertiser” means company or brand contracting with Savers
              App to conduct campaigns to reach and engage customers to drive
              purchases.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.2. “Affiliate” means any person or entity which controls, is
              controlled by or is under common control with the subject entity,
              due to ownership or control of more than fifty percent (50%) of
              the equity securities of the subject entity entitled to vote in
              the election of directors, or otherwise having the power to
              control the management and policies of the subject entity.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.3. “Campaign” means advertising, promotional, or marketing
              campaigns featuring Offers enabled by the Savers App Platform so
              as to allow customers to link Offers to a registered payment card
              in order earn the reward as described in the Offer terms and
              conditions.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.4. “Savers App Platform” means the technology and platform
              (including software, servers, website(s), and associated user
              interface) through which Savers App and its Publisher performs the
              services described in the Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.5. “Financial Institutions” means those financial services
              institutions that have arrangements with Savers App or Publishers
              to facilitate the services described in the Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.6. “Marketing Fee” means the marketing fee as described in the
              Agreement. For clarity, the Marketing Fee is separate from the
              Offer advertised to the consumer.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.7. “Offer” means an advertising, marketing, or promotional
              offer pursuant to which an Advertiser agrees to credit the
              Redemption Value to customers who make an eligible Redemption with
              a linked payment card.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.8. “Offer Listing” means a web page, links, or other
              information about a CLO that the Advertiser makes available for
              presentation to customers on the Savers App Platform.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.9. “Party” refers to the Advertiser, Savers App, and Publisher
              and collectively (“Parties”).
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.10. “Payment Processor” means the company or companies
              authorized by a merchant to collect, process, or settle payment
              card transactions.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.11. “Redemption” (and variations thereof) means the act of
              consummating a purchase of goods or services as advertised in, and
              in accordance with the terms and conditions of the Offer.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.12. “Redemption Matching” means the act of identifying
              Qualified Purchases by validating the occurrence of a Redemption
              by matching transaction data with the terms and conditions of the
              Offer as defined by the Advertiser in the Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.13. “Redemption Value” means the value of the reward available
              to a consumer upon Redemption of an Offer.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              14.14. “Settlement Funds” means cash funds collected from
              Advertiser to be credited to customers’ accounts of validated
              Redemptions.
            </p>

            <h3 className='font-bold mb-2 py-4 pt-10'>
              15. Acceptance and Execution
            </h3>
            <p className='text-base text-gray-700 mb-4'>
              15.1. Acceptance. Advertiser accepts and becomes bound by this
              Agreement by (a) confirming, via the acceptance checkbox
              presented with the Campaign Form, that it has read and agrees to
              these Terms and Conditions; (b) submitting the completed Campaign
              Form; and (c) paying the Onboarding Fee. Completion of all three
              constitutes execution of this Agreement by Advertiser with the
              same force and effect as a handwritten signature.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              15.2. Effective Date. The “Effective Date” of this Agreement is
              the date on which Savers App receives the Onboarding Fee from
              Advertiser.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              15.3. Authority. The individual accepting this Agreement on behalf
              of Advertiser represents and warrants that they are duly
              authorized to bind Advertiser to this Agreement. Advertiser shall
              be bound irrespective of that individual’s internal authority, and
              shall not assert lack of authorization as a defence to enforcement
              of this Agreement.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              15.4. Electronic Records and Signatures. The Parties consent to
              transact electronically and agree that this Agreement may be
              entered into by electronic means. Advertiser agrees that the
              electronic record of its acceptance — including the version of
              these Terms and Conditions accepted, the date and time of
              acceptance, the internet protocol address from which acceptance
              was submitted, the submission identifier, the name and title of
              the accepting individual, and the payment reference for the
              Onboarding Fee — constitutes a valid and binding record of
              execution of this Agreement and is admissible evidence of its
              terms. Advertiser waives any objection to the validity or
              enforceability of this Agreement based solely on the absence of a
              handwritten or electronic signature.
            </p>
            <p className='text-base text-gray-700 mb-4'>
              15.5. Version. The version of these Terms and Conditions accepted
              by Advertiser is identified in the acceptance record and is
              available from Savers App at the versioned location published for
              that version.
            </p>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default MerchantTermsPage;
